import { viewPeriod } from '../services/viewPeriod';
import { State } from '../types/reducer/State';
import { Session } from '../types/Session';
import { viewAgent } from '../services/viewAgent';
import { panelSize } from '../services/panelSize';
import { sideBarPosition } from '../services/sideBarPosition';
import { isMobile } from '../utils/isMobile';

export const initializer = ({ user }: Session): State => {

  return {
    user,
    viewPeriod: viewPeriod.get() || viewPeriod.getDefault(),
    viewAgent: viewAgent.get() || viewAgent.getDefault(),
    panelSize: panelSize.get() || panelSize.getDefault(),
    sideBarPosition: sideBarPosition.get() || sideBarPosition.getDefault(),
    isMobile: isMobile(),

    // 🔴 csak hogy a struktúra fix legyen (de ez felülíródik a Providerben)
    snoozedTodos: [],
    setSnoozedTodos: () => {}
  };
};
